import "./Profile.css";

import { useAppDispatch, useAppSelector } from "../../hooks/reduxHooks";
import { useEffect, useState } from "react";

import AreYouSure from "../../components/modals/AreYouSure/AreYouSure";
import ChangePassword from "../../components/Profile/ChangePassword/ChangePassword";
import Footer from "../../components/Footer/Footer";
import Header from "../../components/Header/Header";
import PaymentHistory from "../../components/Profile/PaymentHistory/PaymentHistory";
import ProfileDetails from "../../components/Profile/ProfileDetails/ProfileDetails";
import { getProfile } from "../../api/auth";
import { logout } from "../../store/indexActions";
import { toast } from "react-toastify";
import { updateProfile } from "../../api/auth";
import { useNavigate } from "react-router";

enum ProfileSection {
  PROFILE_DETAILS = "profile_details",
  CHANGE_PASSWORD = "change_password",
  PAYMENT_HISTORY = "payment-history",
}

const Profile = () => {
  const navigate = useNavigate();
  const user = useAppSelector((state) => state.auth.user);
  const areYouSureVisible = useAppSelector(
    (state) => state.modal.areYouSureVisible
  );

  const [editable, setEditable] = useState<boolean>(false);

  const [email, setEmail] = useState<string>(user?.email!);
  const [mobile, setMobile] = useState<string>(user?.mobile_number!);
  const [emailChanged, setEmailChanged] = useState<boolean>(false);
  const [errors, setErrors] = useState<string[]>([]);

  const [profileSection, setProfileSection] = useState<ProfileSection | null>(
    window.innerWidth > 480 ? ProfileSection.PROFILE_DETAILS : null
  );

  useEffect(() => {
    getProfile(true);
    if (!user) navigate("/");
  }, []);

  useEffect(() => {
    const container = document.getElementById("profile-content-container");
    if (
      container &&
      window.innerWidth <= 480 &&
      profileSection !== ProfileSection.PAYMENT_HISTORY
    ) {
      container.style.border = "none";
      container.style.background = "#F1F1F1";
    } else if (profileSection === ProfileSection.PAYMENT_HISTORY) {
      if (container && window.innerWidth <= 480) {
        container.style.background = "none";
        container.style.border = "none";
      }
    }
  }, [profileSection]);

  useEffect(() => {
    if (emailChanged) {
      setTimeout(() => {
        logout(false);
      }, 6000);
    }
  }, [emailChanged]);

  useEffect(() => {
    if (user?.email) setEmail(user?.email);
    if (user?.mobile_number) setMobile(user?.mobile_number);
  }, [user]);

  const validateEmail = () => {
    setErrors([]);
    if (!email?.trim()) {
      document.getElementById("email-input")!.style.border = "1px solid red";
      setErrors((errors) => [...errors, "Please enter an email"]);
      return false;
    } else {
      document.getElementById("email-input")!.style.border =
        "1px solid #d7d7d7";
    }
    if (!/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(email)) {
      document.getElementById("email-input")!.style.border = "1px solid red";
      setErrors((errors) => [...errors, "Please enter a valid email"]);
      return false;
    } else {
      document.getElementById("email-input")!.style.border =
        "1px solid #d7d7d7";
    }
  };

  const validate = () => {
    validateEmail();
    if (!mobile?.trim()) {
      document.getElementById("mobile-input")!.style.border = "1px solid red";
      setErrors((errors) => [...errors, "Please enter a mobile number"]);
      return false;
    } else {
      document.getElementById("mobile-input")!.style.border =
        "1px solid #d7d7d7";
    }

    if (
      mobile &&
      !/^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s\./0-9]*$/g.test(
        mobile.replace(/ /g, "")
      )
    ) {
      document.getElementById("mobile-input")!.style.border = "1px solid red";
      setErrors((errors) => [...errors, "Please enter a valid mobile number"]);
      return false;
    } else {
      document.getElementById("mobile-input")!.style.border =
        "1px solid #d7d7d7";
    }
    return true;
  };

  const onSaveClicked = () => {
    if (
      email &&
      mobile &&
      validate() &&
      /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(email)
    ) {
      updateProfile(email, mobile, email !== user?.email)
        .then((resp: any) => {
          if (email !== user?.email) {
            setEmailChanged(true);
          }
        })
        .finally(() => {
          setEditable(false);
          toast.success("Profile updated", {
            position: toast.POSITION.TOP_RIGHT,
          });
        });
    }
  };

  const renderSections = () => {
    switch (profileSection) {
      case ProfileSection.PROFILE_DETAILS:
        return (
          <ProfileDetails
            email={email}
            setEmail={setEmail}
            mobile={mobile}
            setMobile={setMobile}
            errors={errors}
            setErrors={setErrors}
            onSaveClicked={onSaveClicked}
            validateEmail={validateEmail}
            setProfileSection={setProfileSection}
            editable={editable}
            setEditable={setEditable}
          />
        );
      case ProfileSection.CHANGE_PASSWORD:
        return (
          <ChangePassword
            errors={errors}
            setErrors={setErrors}
            setProfileSection={setProfileSection}
          />
        );
      case ProfileSection.PAYMENT_HISTORY:
        return <PaymentHistory setProfileSection={setProfileSection} />;

      default:
        break;
    }
  };

  return (
    <>
      {areYouSureVisible && <AreYouSure callback={onSaveClicked} />}
      <div className="profile-container">
        <Header title="City of Cape Town - Traffic Fines" />
        <div className="profile-details">
          <p
            style={{
              display: window.innerWidth <= 480 ? "flex" : "none",
            }}
            className="profile-heading"
          >
            Your Profile
          </p>
          <div className="profile-section">
            <div
              className="profile-left"
              style={{
                display:
                  window.innerWidth <= 480 && profileSection ? "none" : "flex",
              }}
            >
              <p
                style={{
                  display: window.innerWidth <= 480 ? "none" : "flex",
                }}
                className="profile-heading"
              >
                Your Profile
              </p>
              <div
                style={{
                  visibility:
                    window.innerWidth > 480
                      ? "visible"
                      : !profileSection
                      ? "visible"
                      : "hidden",
                }}
                className="selector-container"
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection:
                      window.innerWidth <= 1024 && window.innerWidth > 480
                        ? "row"
                        : "column",
                  }}
                >
                  <div
                    className="profile-section-selector"
                    style={{
                      backgroundColor:
                        profileSection === ProfileSection.PROFILE_DETAILS
                          ? "#e97700"
                          : "#17283c",
                    }}
                    onClick={() =>
                      setProfileSection(ProfileSection.PROFILE_DETAILS)
                    }
                  >
                    Profile Details
                  </div>
                  <div
                    style={{
                      backgroundColor:
                        profileSection === ProfileSection.CHANGE_PASSWORD
                          ? "#e97700"
                          : "#17283c",
                    }}
                    className="profile-section-selector"
                    onClick={() =>
                      setProfileSection(ProfileSection.CHANGE_PASSWORD)
                    }
                  >
                    Change Password
                  </div>
                  <div
                    style={{
                      backgroundColor:
                        profileSection === ProfileSection.PAYMENT_HISTORY
                          ? "#e97700"
                          : "#17283c",
                    }}
                    className="profile-section-selector"
                    onClick={() => {
                      setProfileSection(ProfileSection.PAYMENT_HISTORY);
                    }}
                  >
                    Payment History
                  </div>
                </div>
                {window.innerWidth < 700 || window.innerWidth > 1024 ? (
                  <div
                    className="profile-logout-selector"
                    onClick={() => logout(false)}
                  >
                    Log Out
                  </div>
                ) : null}
              </div>
            </div>
            {profileSection ? (
              <div
                id="profile-content-container"
                className="profile-content-container"
              >
                {renderSections()}
              </div>
            ) : null}
          </div>
        </div>
        {window.innerWidth > 480 &&
        window.innerWidth <= 1024 &&
        window.matchMedia("(orientation: portrait)").matches ? (
          <div
            className="profile-logout-selector"
            onClick={() => logout(false)}
          >
            Log Out
          </div>
        ) : null}
        <Footer />
      </div>
    </>
  );
};

export default Profile;
